<script setup>
import { ref, watch } from "vue";

const props = defineProps({
	steps: {
		type: Array,
		required: true,
	},
	currentStep: {
		type: Number,
		required: true,
	},
	isStepValid: {
		type: Function,
		default: null,
	},
});

const emit = defineEmits(["update:currentStep"]);

// Internal state
const internalCurrentStep = ref(props.currentStep);
// Incoming
watch(
	() => props.currentStep,
	(newValue) => {
		internalCurrentStep.value = newValue;
	},
);
// Outgoing
watch(internalCurrentStep, (newValue) => {
	emit("update:currentStep", newValue);
});

// Step navigation
const nextStep = () => {
	goToStep(internalCurrentStep.value + 1);
};

const prevStep = () => {
	goToStep(internalCurrentStep.value - 1);
};

const goToStep = (step) => {
	// Make sure the previous step is valid
	if (step >= 1 && !props.isStepValid(step - 1)) return;

	if (step >= 0 && step < props.steps.length) {
		internalCurrentStep.value = step;
	}
};

// Expose functions to parent component
defineExpose({
	goToStep,
	nextStep,
	prevStep,
	getCurrentStep: () => internalCurrentStep.value,
});
</script>

<template>
	<div class="section-progress pt-0">
		<div class="steps">
			<div class="row">
				<div
					v-for="(step, index) in steps"
					:key="index"
					class="col step"
					:class="{
						active: index === currentStep,
						complete: index < currentStep,
					}"
					@click="goToStep(index)"
				>
					<div class="step-number">{{ index + 1 }}</div>
					<div class="step-title">{{ step }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.step-number {
	cursor: pointer;
}
</style>
